import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { NotificationHeader } from './containers/NotificationHeader';
import { NotificationList } from './containers/NotificationList';
import { RegistrationModal } from './containers/RegistrationModal';
import { EditModal } from './containers/EditModal';

export const NotificationPageView: FC = () => (
  <Box m="40px 40px">
    {/* ヘッダ */}
    <NotificationHeader />
    {/* お知らせ一覧 */}
    <NotificationList />
    {/* お知らせ新規登録モーダル */}
    <RegistrationModal />
    {/* お知らせ更新モーダル */}
    <EditModal />
  </Box>
);
